import React from 'react'
import MaskedInput from 'react-maskedinput'
import './InputText.css'

export default (props) => (
  props.textArea ? <textarea
      className="input-text"
      {...props}
    /> :
    props.mask ?
      <MaskedInput
        className="input-text"
        {...props}
      />
      :
      <input
        className="input-text"
        {...props}
      />
)


// WEBPACK FOOTER //
// ./src/basic/InputText.js